var amdi18n={"__root":{"privacy_text":"<h1>Herzlich Willkommen beim Fifty-Fifty-eKiosk!</h1><p>Hier können Sie mit Ihrem Personalausweis in Verbindung mit der FiftyFifty-App Ihre FiftyFifty-Taxi Berechtigung (eTicket) erstellen und auf Ihr Mobiltelefon übertragen.</p><p>Sie benötigen hierfür Ihren Personalausweis mit aktivierter eID-Funktion und die dazugehörige (sechsstellige) eID-PIN.</p>"},"__de":{"privacy_text":"<h1>Herzlich Willkommen beim Fifty-Fifty-eKiosk!</h1><p>Hier können Sie mit Ihrem Personalausweis in Verbindung mit der FiftyFifty-App Ihre FiftyFifty-Taxi Berechtigung (eTicket) erstellen und auf Ihr Mobiltelefon übertragen.</p><p>Sie benötigen hierfür Ihren Personalausweis mit aktivierter eID-Funktion und die dazugehörige (sechsstellige) eID-PIN.</p>"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/view/kiosk/nls/PrivacyPolicyView_strings.js
// module id = 356
// module chunks = 1